class GivexForm extends HTMLElement {
  constructor() {
    super();
    this.giftCardContainer = this.querySelector('[data-givex-container]');

    const formList = this.closest('.shopify-section').querySelectorAll('form[action$="/cart/add"]:not([id*="product-form-installment"])');
    this.form = formList[0];
    this.buttonSubmit = this.form.querySelector('[name="add"]');
    const formID = this.form.getAttribute('id');

    if (this.giftCardContainer) {
      this.giftCardValues = Array.from(this.giftCardContainer.querySelectorAll('input'));
      this.giftCardWarning = this.querySelector("[data-giftcard-warning]");
      this.hiddenForm = this.querySelector("[data-givex-form-hidden]");
      this.senderEmail = this.querySelector('[data-givex-sender-email]');
      this.recipientEmail = this.querySelector('[data-givex-recipient-email]');
      this.recipientAsterix = this.querySelector('[data-recipient-asterix]');

      this.senderName = this.querySelector('[data-givex-sender-name]');
      this.recipientName = this.querySelector('[data-givex-recipient-name]');
      this.differentEmailWarning = this.querySelector('[data-different-email-warning]');
      this.message = this.querySelector('[data-givex-message]');

      this.invalidSenderEmail = this.querySelector('[data-invalid-sender-email]');
      this.invalidRecipientEmail = this.querySelector('[data-invalid-recipient-email]');

      this.senderEmail.setAttribute('form', formID);
      this.recipientEmail.setAttribute('form', formID);
      this.senderName.setAttribute('form', formID);
      this.recipientName.setAttribute('form', formID);
      this.message.setAttribute('form', formID);

      this.inputs = this.querySelectorAll('input');
      this.inputs.forEach(input => {
        input.addEventListener('input', this.handleGiftCardForm.bind(this));
      })
    }

    this.buttonSubmit.addEventListener('click', this.handleGiftCardForm.bind(this));
    setInterval(() => {
      this.handleGiftCardForm();
    }, 500);
  }

  checkGiftCardFilled() {
    this.recipientEmailValue = this.recipientEmail.value;
    this.senderEmailValue = this.senderEmail.value;
    let validRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if(this.recipientEmailValue) {
        // show the hidden fields
        this.hiddenForm.classList.remove('givex__form-hidden');
        this.recipientEmail.setAttribute('required', true);
        this.senderName.setAttribute('required', true);
        this.recipientName.setAttribute('required', true);
        this.differentEmailWarning.classList.add('givex__form-hidden');
        this.recipientAsterix.classList.remove('givex__form-hidden');
    }
    else {
      this.hiddenForm.classList.add('givex__form-hidden');
      this.recipientEmail.removeAttribute('required');
      this.senderName.removeAttribute('required');
      this.recipientEmail.removeAttribute('required');
      this.recipientName.removeAttribute('required');
      this.differentEmailWarning.classList.remove('givex__form-hidden');
      this.recipientAsterix.classList.add('givex__form-hidden');
      this.invalidRecipientEmail.classList.add('givex__form-hidden');
      this.senderName.value = "";
      this.recipientName.value = "";
      this.message.value = "";
    }

    if(this.senderEmailValue){
      if(!this.senderEmailValue.toLowerCase().trim().match(validRegex)) {
        this.invalidSenderEmail.classList.remove('givex__form-hidden');
      }
      else {
        this.invalidSenderEmail.classList.add('givex__form-hidden');
      }
    }

    if(this.recipientEmailValue) {
      if(!this.recipientEmailValue.toLowerCase().trim().match(validRegex)) {
        this.invalidRecipientEmail.classList.remove('givex__form-hidden');
      } else {
        this.invalidRecipientEmail.classList.add('givex__form-hidden');
      }
    }
  }

  handleGiftCardForm(event) {
    this.checkGiftCardFilled();

    if(!this.form.checkValidity()) {
      this.buttonSubmit.disabled = true;
      event.preventDefault();
    }
    else {
      this.buttonSubmit.disabled = false;
    }
  }
}

try {
  customElements.define('givex-form', GivexForm);
}
catch(e) {}